import React from 'react';
import { Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { faCircleCheck, faClock, faCircleExclamation, faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { ProspectAccountMember } from 'bundles/connect/types';


type ProspectMemberStatusProps = {
  member: ProspectAccountMember;
}

export default function ProspectMemberStatus({ member }: ProspectMemberStatusProps) {
  let badgeColor = 'success';
  let badgeIcon = <FontAwesomeIcon icon={faCircleCheck} />;

  switch (member.status) {
  case 'Invited':
    badgeColor = 'warning';
    badgeIcon = <FontAwesomeIcon icon={faClock} />;
    break;
  case 'Inactive':
    badgeColor = 'destructive';
    badgeIcon = <FontAwesomeIcon icon={faCircleExclamation} />;
    break;
  }

  const badge =
    <Badge bg={badgeColor}>
      {badgeIcon}
      {member.status}
    </Badge >;

  if (member.status === 'Empty') {
    return (
      <Button
        className="p-0"
        data-bs-target={`#inviteMemberModal${member.id}`}
        data-bs-toggle="modal"
        variant="text-primary"
      >
        <FontAwesomeIcon icon={faPaperPlane} />
        Invite User
      </Button>
    );
  }

  if (member.status === 'Inactive') {
    return (
      <OverlayTrigger
        overlay={
          <Tooltip id={`member-tooltip-${member.id}`}>
            This user has not logged in for over 30 days.
          </Tooltip>
        }
        placement="right"
        popperConfig={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            }
          ]
        }}
      >
        {badge}
      </OverlayTrigger>
    );
  }

  return badge;
}
